module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box"
  }, [_c('div', {
    staticClass: "row card-box-o"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "col-sm-6 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "sp1-reg",
    staticStyle: {
      "background": "#ffffff",
      "padding": "2em",
      "padding-top": "0",
      "border-radius": "2px"
    }
  }, [(_vm.loading) ? _c('div', [_vm._m(0)]) : _c('div', {
    staticClass: "card"
  }, [_c('div', [_c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Product Details")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', [_vm._v("₦" + _vm._s(_vm.product_item.product_item_price_f))]), _vm._v(" "), _c('div', {
    staticClass: "category-slide"
  }, [_c('ul', _vm._l((_vm.product.product_images), function(img) {
    return _c('li', {}, [(img.product_image && (img.product_image != '' && img.product_image != 'error')) ? _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": _vm.img_product_url + img.product_image,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "pb_img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.product.product_images && (_vm.product.product_images.length > 1)) ? _c('div', [_c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_vm._v("Swipe to see all pictures >>")])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-box-o"
  }, [_c('h3', [_vm._v("Details")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.product_description))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn sp-button-02",
    attrs: {
      "href": '/manage/order/' + _vm.product.product_url_name
    }
  }, [_vm._v("Reset Order")])])])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ce097ef"}!./src/pages/SetOrder/template.html
// module id = 540
// module chunks = 0